<template>
    <div class="field" style="padding-right: 15px;">
        <a class="button is-danger is-outlined"
           v-bind:class="{ 'is-loading': isLoading }"
           @click.prevent="bidCancel()">
            <span>Cancel Bid</span>
            <span class="icon is-small">
                <i class="far fa-trash-alt"></i>
            </span>
        </a>
    </div>
</template>

<script>
    import apiBids from '../../../../api/apiBids'
    export default {
        props: ['bid'],
        data() {
            return {
                isLoading: false,
                currentBid: {
                    id: this.bid.id,
                    status: this.$bidStatusCancel
                }
            }
        },
        methods: {
            bidCancel() {
                this.isLoading = true
                apiBids
                    .updateBidRequest(this.currentBid)
                    .then((response) => {
                        this.isLoading = false
                        this.bid.status = this.$bidStatusCancel
                    })
                    .catch((err) => {
                        console.log(err)
                        this.isLoading = false
                    })
            }
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Card/Buttons/Bids/BidCancel.vue